import { OWNER_TYPES } from "@/static/ownerTypes";
import { Expose } from "class-transformer";
import { IsBoolean, IsEnum, IsNumber, IsString, IsOptional } from "class-validator";

export class OfficeProfileOwner {
  @IsNumber()
  @Expose()
  id!: number;
  @IsString()
  @Expose()
  userId!: string;
  @IsString()
  @Expose()
  name!: string;
  @IsOptional()
  @IsString()
  @Expose()
  friendlyName!: string | null;
  @IsEnum(OWNER_TYPES)
  @Expose()
  type!: OWNER_TYPES;
  @IsBoolean()
  @Expose()
  isLocked!: boolean;
}

export class OfficeOwner extends OfficeProfileOwner {
  @IsBoolean()
  @Expose()
  isAssignedToOffice!: boolean;
}
